<template>
  <b-layout :colors="$site.colors" header-title="Online Booking Disabled" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <h4 class="text-center text-primary font-semibold mb-3">
        {{ $t('pages.widget.disabled.title') }}
      </h4>
      <p class="text-center text-secondary text-sm">
        {{ $t('pages.widget.disabled.message', { location: businessName }) }}
      </p>
    </b-container>
  </b-layout>
</template>

<script>
import Utils from '@/utils'
import LayoutMixin from '@/mixins/layout'

export default {
  mixins: [LayoutMixin],
  layout: 'widget',
  middleware: ['location'],
  computed: {
    homeRoute () {
      return this.$store.getters.homeRoute || { path: '/' }
    },
    businessName () {
      if (this.$site.tabs.contact && this.$site.tabs.contact.business) {
        return this.$site.tabs.contact.business
      } else {
        return this.$site.location.title
      }
    }
  },
  created () {
    this.$store.dispatch('setLayout', 'widget')
  },
  methods: {
    formatHtml (text) {
      return Utils.text.formatHtml(text)
    }
  }
}
</script>
